"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Contact = require("./Contact");
Object.keys(_Contact).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Contact[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Contact[key];
    }
  });
});
